import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Input from 'component/atom/forms/input/input/Input';
import Modal from 'component/hoc/modal/Modal';
import { usePost } from 'hooks/usePost';
import Toggle from 'component/atom/forms/toggle/Toggle';
import { keywordsEndpoints } from 'hooks/endpoints';
import { sensitiveKeywordsToast } from 'helpers/toastMessages';
const Form = ({ formik }) => {
  return (
    <form
      autoComplete="off"
      onSubmit={formik.handleSubmit}
      className="formCont"
    >
      <Input
        label="Name"
        placeholder="Enter Keyword"
        name="keyword"
        value={formik.values.keyword}
        onChange={formik.handleChange}
        error={formik.errors.keyword}
        touched={formik.touched.keyword}
      />
      <Toggle
        left
        label="Set As Default"
        name="isDefault"
        value={formik.values.isDefault}
        onChange={formik.handleChange}
      />
    </form>
  );
};
const AddKeyword = ({ isOpen, onClose, id, item, setRefetch }) => {
  const { mutate: AddKeyword, isPending } = usePost({
    onSuccessToast: sensitiveKeywordsToast.add,
    toastType: 'add',
  });
  const { mutate: EditKeyword, isPending: isEditing } = usePost({
    onSuccessToast: sensitiveKeywordsToast.update,
    toastType: 'update',
  });

  const validationSchema = Yup.object({
    keyword: Yup.string().required('Keyword name is Required'),
    isDefault: Yup.boolean(),
  });
  const formik = useFormik({
    initialValues: {
      keyword: item?.keyword || '',
      isDefault: item?.isDefault || false,
    },
    validationSchema,
    onSubmit: (values) => {
      item !== null
        ? EditKeyword(
            {
              data: {
                ...values,
                id: item?.id,
              },
              url: keywordsEndpoints.update,
              method: 'Put',
            },
            {
              onSuccess: () => {
                onClose();
                setRefetch((prev) => !prev);
              },
            }
          )
        : AddKeyword(
            {
              data: {
                ...values,
                botId: id,
              },
              url: keywordsEndpoints.create,
            },
            {
              onSuccess: () => {
                onClose();
                setRefetch((prev) => !prev);
              },
            }
          );
    },
    enableReinitialize: true,
  });

  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);
  return (
    <div>
      <Modal
        title="Add Keyword"
        isOpen={isOpen}
        onClose={onClose}
        modalContent={{
          component: <Form formik={formik} />,
        }}
        onSubmit={formik.handleSubmit}
        buttonType="submit"
        onSubmitstyles={{
          onSubmit: {
            label: 'Save',
            type: 'save',
          },
        }}
        isLoading={isPending || isEditing}
      />
    </div>
  );
};

export default AddKeyword;
